<template>
  <div class="tp_body">
    <div class="tp_left">
      <infoA
        :userid="suid"
        :teaId="userid"
        :oid="oid"
        :org="org"
        :cid="cid"
        :role="role"
        :key="suid+'a'"
        @updateUid="updateUid"
      ></infoA>
      <panelA :userid="suid" :oid="oid" :org="org" :key="suid+num"></panelA>
    </div>
    <div class="tp_right">
      <testA :userid="suid" :oid="oid" @updatePanelA="updatePanelA" :org="org" :cid="cid" :fathType="fathType" :key="suid+'c'"></testA>
    </div>
  </div>
</template>

<script>
import infoA from "./info/index.vue";
import panelA from "./panel/index.vue";
import testA from "./test/index.vue";

export default {
  components: {
    infoA,
    panelA,
    testA
  },

  data() {
    return {
      userid: this.$route.query.userid,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      cid: this.$route.query.cid,
      suid: this.$route.query.suid,
      role: this.$route.query.role,
      fathType: this.$route.query.fathType,
      num:0
    };
  },
  // watch: {
  //   $route(to, from) {
  //     console.log("bbbbbbbbbbbbbbbbbbbbb刷新了");
  //     // 监听$route变化，当参数发生变化时执行逻辑
  //     // this.$forceUpdate();
  //     this.$router.go(0);
  //     // window.location.reload();
  //   }
  // },
  methods: {
    updateUid(e){
      console.log('更新',e);
      this.suid = e
    },
    updatePanelA(e){
      console.log('更新PanelA',e);
      this.num=e
    }
  }
};
</script>

<style scoped>
.tp_body {
  width: 100%;
  height: 100%;
  min-height: 820px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
}

.tp_left {
  width: 230px;
  height: 100%;
}
.tp_right {
  width: calc(100% - 230px - 10px);
  margin: 0 0 0 10px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kindStudentEva/index.vue